export const LOAD_PAGAMENTOS = "LOAD_PAGAMENTOS";
export const SET_PAGE_PAGAMENTO = "SET_PAGE_PAGAMENTO";
export const SET_PERPAGE_PAGAMENTO = "SET_PERPAGE_PAGAMENTO";
export const SET_TOTAL_PAGAMENTO = "SET_TOTAL_PAGAMENTO";
export const SET_PAGAMENTO = "SET_PAGAMENTO";
export const LOADING_PAGAMENTO = "LOADING_PAGAMENTO";
export const SET_FILTRO_PAGAMENTO = "SET_FILTRO_PAGAMENTO";
